import { Link } from 'react-router-dom';
import SEOMeta from '@/components/base/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import VideoCard from '@/components/base/VideoCard';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import { getHotVideos, getNewVideos, videos } from '@/mocks/videos';
import { categories } from '@/mocks/categories';

export default function Home() {
  const hotVideos = getHotVideos();
  const newVideos = getNewVideos();
  const featuredVideos = videos.slice(0, 6);

  return (
    <>
      <SEOMeta
        title="在线免费观看·全集高清资源"
        description="想找星空传媒在线免费观看？本站汇聚星空传媒全系列高清视频，无需下载、无需注册，随时随地免费在线播放。海量剧集持续更新，画质清晰流畅，让你畅享星空传媒精彩内容。"
        keywords="星空传媒在线免费观看,星空传媒免费视频,星空传媒全集在线播放,星空传媒高清资源,星空传媒最新剧集,星空传媒无广告播放"
        canonicalUrl="https://sportzup.github.io/"
        ogTitle="星空传媒在线免费观看·全集高清资源"
        ogDescription="本站汇聚星空传媒全系列高清视频，无需下载、无需注册，随时随地免费在线播放。"
      />

      <Navbar />

      <main>
        <article>
          <HeroSection />

          <CategoryNav />

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                    热门推荐
                  </h2>
                  <p className="text-sm text-foreground-500 mt-1">全网热播，大家都在看</p>
                </div>
                <Link
                  to="/category/drama"
                  className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
                >
                  查看更多
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop="">
                {hotVideos.map((video) => (
                  <VideoCard key={video.id} video={video} />
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                    最新上线
                  </h2>
                  <p className="text-sm text-foreground-500 mt-1">每日更新，精彩不断</p>
                </div>
                <Link
                  to="/category/movie"
                  className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
                >
                  查看更多
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop="">
                {newVideos.map((video) => (
                  <VideoCard key={video.id} video={video} />
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-8">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                  精选内容
                </h2>
                <p className="text-sm text-foreground-500 mt-1">编辑精选，品质保证</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop="">
                {featuredVideos.map((video) => (
                  <VideoCard key={video.id} video={video} />
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-12 md:py-16">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-8">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                  常见问题
                </h2>
                <p className="text-sm text-foreground-500 mt-1">关于星空传媒的常见疑问解答</p>
              </div>
              <div className="max-w-3xl mx-auto space-y-3">
                {[
                  {
                    q: '星空传媒需要注册才能观看吗？',
                    a: '不需要！星空传媒所有视频内容完全免费，无需注册、无需登录，打开网站即可在线观看。',
                  },
                  {
                    q: '星空传媒的视频画质如何？',
                    a: '我们提供高清乃至4K超清画质，采用先进的视频编码技术，在保证清晰度的同时实现流畅播放。',
                  },
                  {
                    q: '星空传媒支持哪些设备观看？',
                    a: '星空传媒全面支持电脑、平板、手机等各类设备，适配不同屏幕尺寸，随时随地畅享观影体验。',
                  },
                  {
                    q: '视频内容多久更新一次？',
                    a: '我们每天都会更新最新剧集和电影资源，热门内容第一时间上线，让你不再错过任何精彩。',
                  },
                  {
                    q: '星空传媒有广告吗？',
                    a: '星空传媒致力于提供纯净的观影体验，全程无广告打扰，让你专注于精彩内容本身。',
                  },
                ].map((faq, index) => (
                  <details key={index} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
                    <summary className="flex items-center justify-between cursor-pointer p-5 text-sm font-medium text-foreground-900 hover:text-primary-700 transition-colors">
                      <span>{faq.q}</span>
                      <div className="w-5 h-5 flex items-center justify-center ml-3 group-open:rotate-180 transition-transform">
                        <i className="ri-arrow-down-s-line text-foreground-400"></i>
                      </div>
                    </summary>
                    <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>
        </article>
      </main>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: '星空传媒需要注册才能观看吗？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '不需要！星空传媒所有视频内容完全免费，无需注册、无需登录，打开网站即可在线观看。',
              },
            },
            {
              '@type': 'Question',
              name: '星空传媒的视频画质如何？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '我们提供高清乃至4K超清画质，采用先进的视频编码技术，在保证清晰度的同时实现流畅播放。',
              },
            },
            {
              '@type': 'Question',
              name: '星空传媒支持哪些设备观看？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '星空传媒全面支持电脑、平板、手机等各类设备，适配不同屏幕尺寸，随时随地畅享观影体验。',
              },
            },
            {
              '@type': 'Question',
              name: '视频内容多久更新一次？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '我们每天都会更新最新剧集和电影资源，热门内容第一时间上线，让你不再错过任何精彩。',
              },
            },
            {
              '@type': 'Question',
              name: '星空传媒有广告吗？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '星空传媒致力于提供纯净的观影体验，全程无广告打扰，让你专注于精彩内容本身。',
              },
            },
          ],
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '星空传媒在线免费观看·全集高清资源',
          description: '想找星空传媒在线免费观看？本站汇聚星空传媒全系列高清视频，无需下载、无需注册，随时随地免费在线播放。',
          url: 'https://sportzup.github.io/',
          isPartOf: {
            '@type': 'WebSite',
            name: '星空传媒',
            url: 'https://sportzup.github.io/',
          },
          about: {
            '@type': 'Organization',
            name: '星空传媒',
            url: 'https://sportzup.github.io/',
          },
        })}
      </script>
    </>
  );
}